<script context='module'>
  import { getContext } from 'svelte';

  const CHECKBOX_GROUP = Symbol('CheckboxGroup');
  export const INDETERMINATE = Symbol('Indeterminate');

  export const useCheckboxGroup = () => getContext(CHECKBOX_GROUP);
  export { CHECKBOX_GROUP as CONTEXT_KEY };
</script>

<script>
  import { writable } from 'svelte/store';
  import Provider from '../Provider';

  export let allowIndeterminate = false;
  export let value = new Map();

  const group = writable(
    allowIndeterminate || !Array.isArray(value)
      ? value
      : new Map(value.map((key) => [key, true])),
  );
  $: value = allowIndeterminate ? $group : [...$group.keys()];
  $: group.set(allowIndeterminate ? value : new Map(value.map((key) => [key, true])));
</script>

<Provider key={CHECKBOX_GROUP} value={group}>
  <slot />
</Provider>
